/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { Address } from "./Address";

export interface PhysicalMailProviderData {
  recipient_address: Address;
  provider_letter_id?: string | null;
  tracking_number?: string | null;
  carrier?: string | null;
  expected_delivery_date?: string | null;
  provider_status?: string | null;
}
